import { Stack } from "@mui/material";
import BadgedAvatar from "../base/BadgedAvatar";
import { assertThumbnailUrl } from "../../redux/common";
import { UserInfo } from "../../redux/user/userSlice";

interface UserStackProps {
    users?: UserInfo[];
}

const UserStack = ({ users }: UserStackProps) => {
    if (!users || users.length === 0) return <>-</>;
    return (
        <Stack direction="column" spacing={0.5} flexWrap="wrap" sx={{my: 1}}>
            {users.map(f => (
                <Stack key={f.id} direction="row" alignItems="center">
                    <BadgedAvatar
                        title={f.name || f.email || f.id}
                        avatar={assertThumbnailUrl(f.url)}
                        size="24px"
                        fontSize="12px"
                        marginRight={1}
                    />
                    {f.name || f.email || f.id}
                </Stack>
            ))}
        </Stack>
    );
};

export default UserStack;
